import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EventTrackerInterface } from '@commons/tracker/event-tracker/event-tracker.interface';

@Component({
  selector: 'app-link',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkComponent {
  @Input() path: string;

  @Input() fragment: string;

  @Input() label: string;

  @Input() exact = false;

  @Input() notificationContent: string | number;

  @Input() event: EventTrackerInterface;
}
